// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PrescriberV3ClientGeneratedContactDatePreferenceType } from './prescriberV3ClientGeneratedContactDatePreferenceType.js';
import type { PrescriberV3ClientGeneratedContactInformationPurposeType } from './prescriberV3ClientGeneratedContactInformationPurposeType.js';
import type { PrescriberV3ClientGeneratedContactTimePreferenceType } from './prescriberV3ClientGeneratedContactTimePreferenceType.js';
import type { PrescriberV3ClientGeneratedPhoneContactInformationType } from './prescriberV3ClientGeneratedPhoneContactInformationType.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PrescriberV3ClientGeneratedPhoneUpsearchModel {
    'phoneId'?: number | null;
    'phoneType'?: PrescriberV3ClientGeneratedPhoneContactInformationType;
    'phonePurpose'?: PrescriberV3ClientGeneratedContactInformationPurposeType;
    'phoneNumber': string;
    'extension': string;
    'contactDatePreferenceType'?: PrescriberV3ClientGeneratedContactDatePreferenceType;
    'bestDaysToCall': string;
    'contactTimePreferenceType'?: PrescriberV3ClientGeneratedContactTimePreferenceType;
    'bestTimeToCall': string;
    'language': string;
    'timeZone': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PrescriberV3ClientGeneratedPhoneUpsearchModel>> = [
        {
            "name":     "phoneId",
            "baseName": "phoneId",
            "type":     "number"
        },
        {
            "name":     "phoneType",
            "baseName": "phoneType",
            "type":     "PrescriberV3ClientGeneratedPhoneContactInformationType"
        },
        {
            "name":     "phonePurpose",
            "baseName": "phonePurpose",
            "type":     "PrescriberV3ClientGeneratedContactInformationPurposeType"
        },
        {
            "name":     "phoneNumber",
            "baseName": "phoneNumber",
            "type":     "string"
        },
        {
            "name":     "extension",
            "baseName": "extension",
            "type":     "string"
        },
        {
            "name":     "contactDatePreferenceType",
            "baseName": "contactDatePreferenceType",
            "type":     "PrescriberV3ClientGeneratedContactDatePreferenceType"
        },
        {
            "name":     "bestDaysToCall",
            "baseName": "bestDaysToCall",
            "type":     "string"
        },
        {
            "name":     "contactTimePreferenceType",
            "baseName": "contactTimePreferenceType",
            "type":     "PrescriberV3ClientGeneratedContactTimePreferenceType"
        },
        {
            "name":     "bestTimeToCall",
            "baseName": "bestTimeToCall",
            "type":     "string"
        },
        {
            "name":     "language",
            "baseName": "language",
            "type":     "string"
        },
        {
            "name":     "timeZone",
            "baseName": "timeZone",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return PrescriberV3ClientGeneratedPhoneUpsearchModel.attributeTypeMap;
    }
}
